var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartSimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.452148 8.38095C0.452148 7.53938 1.13438 6.85714 1.97596 6.85714H3.59501C4.43658 6.85714 5.11881 7.53938 5.11881 8.38095V14.4762C5.11881 15.3178 4.43658 16 3.59501 16H1.97596C1.13438 16 0.452148 15.3178 0.452148 14.4762V8.38095Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16643 1.52381C6.16643 0.682233 6.84867 0 7.69024 0H9.30929C10.1509 0 10.8331 0.682233 10.8331 1.52381V14.4762C10.8331 15.3178 10.1509 16 9.30929 16H7.69024C6.84867 16 6.16643 15.3178 6.16643 14.4762V1.52381Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8807 3.80952C11.8807 2.96795 12.563 2.28571 13.4045 2.28571H15.0236C15.8652 2.28571 16.5474 2.96795 16.5474 3.80952V14.4762C16.5474 15.3178 15.8652 16 15.0236 16H13.4045C12.563 16 11.8807 15.3178 11.8807 14.4762V3.80952Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartSimple);
export default __webpack_public_path__ + "static/media/chart-simple.620709a9b2bc995a273acf1f738448f9.svg";
export { ForwardRef as ReactComponent };